<a class="listTitle" translate> <span class="esri-icon-collection" aria-hidden="true"></span>COMMON.WEBGIS_APPS</a>
<ul class="" style="list-style: none" *ngFor="let webGisApp of webGisApps;">
  <li>
    <a href="{{goToWebGisApp(webGisApp.app)}}" target="_blank">
      <span class="esri-icon-maps" aria-hidden="true"></span>{{webGisApp.name}}</a>
  </li>
</ul>
